export const PUBLIC_PRIVACY_POLICY_PATH = "/terms?type=PRIVACY";
export const MY_PRIVACY_POLICY_PATH = `${PUBLIC_PRIVACY_POLICY_PATH}&returnTo=%2Fapp%2Fmy%2Fterms`;

export function isPublicPrivacyRequest(search: string): boolean {
  return new URLSearchParams(search).get("type") === "PRIVACY";
}

/** Only this fixed MY destination is accepted; arbitrary return URLs never run. */
export function publicPrivacyBackTo(search: string, authenticated: boolean, fallback: string): string {
  return authenticated && isPublicPrivacyRequest(search) && new URLSearchParams(search).get("returnTo") === "/app/my/terms"
    ? "/app/my/terms" : fallback;
}
